import React, { useState, useContext } from 'react';
import { Heart } from 'iconsax-react';
import { ThemeContext } from '../theme';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

export default function LibraryStoryCard({ image, title, category, onClick }) {
  const theme = useContext(ThemeContext);
  const [liked, setLiked] = useState(false);

  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: theme.cardBg,
        border: `1px solid ${theme.border}`,
        borderRadius: s(12),
        padding: s(12),
        display: 'flex',
        flexDirection: 'column',
        gap: s(12),
        width: s(224),
        flexShrink: 0,
        boxSizing: 'border-box',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      {/* Cover image */}
      <div style={{ height: s(126), borderRadius: s(10), overflow: 'hidden', flexShrink: 0 }}>
        <img
          src={image}
          alt={title}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </div>

      {/* Title + category + heart */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: s(2) }}>
        <span
          className="font-satoshi font-bold"
          style={{
            fontSize: s(18),
            lineHeight: `${s(24)}px`,
            color: theme.text100,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
          }}
        >
          {title}
        </span>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span
            className="font-satoshi"
            style={{ flex: 1, fontSize: s(14), fontWeight: 500, color: theme.text400, lineHeight: `${s(20)}px` }}
          >
            {category}
          </span>
          <button
            onClick={(e) => { e.stopPropagation(); setLiked(l => !l); }}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}
          >
            <Heart size={s(24)} variant={liked ? 'Bold' : 'Linear'} color={liked ? '#d46c6c' : theme.text400} />
          </button>
        </div>
      </div>
    </div>
  );
}
